"use client";

import { LinkButton } from "@/components/links/LinkButton";
import { useSetAuthModalOpen } from "@/lib/clerk/useSetAuthModalOpen";
import { usePricingModal } from "@/lib/zustand/usePricingModal";
import { UserNoDates } from "@/types/types";
import { allowWavConversions } from "@/utils/subscriptionLevels/allowWavConversions";

export function AudioQualityText({ user }: { user: UserNoDates | null }) {
  const setPricingModalOpen = usePricingModal((state) => state.setOpen);
  const setAuthModalOpen = useSetAuthModalOpen();

  const wavAvailable =
    user !== null && allowWavConversions(user.stripeSubscriptionId);

  if (wavAvailable) {
    return null;
  }

  return (
    <>
      {" "}
      <LinkButton
        onClick={() => {
          if (user === null) {
            setAuthModalOpen();
            return;
          }
          setPricingModalOpen();
        }}
        className="text-sm"
      >
        Upgrade
      </LinkButton>{" "}
      for higher quality of downloads.
    </>
  );
}
